module.exports = __webpack_public_path__ + "static/checkbox-2-0f56aab56ed800b1691662f84aee3e60.png";